import { useState } from 'react';
import useMountEffect from 'hooks/useMountEffect';

// Watches the `window.chmln` property and sets a flag when it's defined
export const useChameleonListener = (): boolean => {
    const [chameleonIsDefined, setChameleonIsDefined] = useState(
        Boolean((window as unknown as { chmln: unknown })?.chmln),
    );

    useMountEffect(() => {
        !chameleonIsDefined &&
            Object.defineProperty(window, 'chmln', {
                configurable: true,
                set: function (x) {
                    this._chmln = x;
                    setChameleonIsDefined(true);
                },
                get: function () {
                    return this._chmln;
                },
            });
    });

    return chameleonIsDefined;
};
